<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span class="glyphicon glyphicon-th-list"></span> {{label}}</button>

<dx-popup class="popup"
          [height]="'auto'"
          [width]="'80%'"
          title="Ausnahme"
          [showTitle]="true"
          [(visible)]="popupVisible"
          style="display: inline-block;">

  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView
                    id="scrollview"
                    [scrollByContent]="true"
                    [scrollByThumb]="true"
                    [showScrollbar]="'onHover'"
                    reachBottomText="Updating...">
      <div style="padding-right: 15px;">
        <cz-ausnahme *ngIf="popupVisible" (onNotValid)="onNotValid($event)" (onCloseOk)="onCloseOkEvent($event)" [eId]="eId" [optional]="optional" [events]="eventsSubject.asObservable()"></cz-ausnahme>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Übernehmen',
            onClick: save,
            disabled: isSaving
        }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: closePopup,
            disabled: isSaving
        }">
  </dxi-popup-toolbar-item>

</dx-popup>
